import { Observable } from 'rxjs';

import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SchedulerEvent } from '@progress/kendo-angular-scheduler';

@Component({
  selector: 'app-scheduler',
  templateUrl: "./scheduler.component.html",
  styleUrls: ["./scheduler.component.scss"],
})
export class SchedulerComponent implements OnInit {
  @Input() events: Observable<SchedulerEvent[]>;
  @Input()  pdfName: string;
  @Input()  isLoading: string;

  fileName: string;
  isDetailedView = false; 
  public today = new Date();
  options = {
    startTime: "7:00",
    endTime: "19:00",
    selectedViewIndex: 1,
  };

  constructor(public datepipe: DatePipe) {}

  ngOnInit(): void {
    const date = this.datepipe.transform(new Date(), "dd_MM_yyyy");
    this.fileName = `${this.pdfName}_${date}.pdf`;
  }

  setColor(employeeId: number) {
    if (employeeId >= 30) {
      return "user_30";
    }

    if (employeeId >= 20) {
      return "user_20";
    }
    return employeeId ? `user_${employeeId}` : "user_default";
  }

  isDetailedViewChanged(value: any): void {
    if(value){
      this.options.selectedViewIndex = 3;
    }
    else{
      this.options.selectedViewIndex = 1;
    }

  }
}
